import React, { useState } from 'react';
import { PasswordlessOtpStep } from './PasswordlessOtpStep';
import { PasswordlessRequestStep } from './PasswordlessRequestStep';
import { SignInProps } from './SignIn';

export type PasswordlessFrameProps = Required<Pick<SignInProps, 'title'>> &
  Pick<SignInProps, 'className' | 'showSocialAuth' | 'showAuthModal' | 'hideAuthModal' | 'onAuth'>;

type PasswordlessSignInProps = Required<Pick<SignInProps, 'title'>> &
  SignInProps & {
    requestMessage?: string;
    disableRequestEmail?: boolean;
  };

export const PasswordlessSignIn: React.FC<PasswordlessSignInProps> = ({
  onAuth,
  className,
  showSocialAuth = true,
  showCancelButton,
  defaultValues,
  showAuthModal,
  hideAuthModal,
  changePayment,
  title,
  requestMessage,
  disableRequestEmail = false
}) => {
  const [email, setEmail] = useState('');

  if (!email) {
    return (
      <PasswordlessRequestStep
        className={className}
        defaultEmail={defaultValues?.signInEmail}
        disableEmail={disableRequestEmail}
        hideAuthModal={hideAuthModal}
        message={requestMessage}
        onAuth={onAuth}
        onRequested={setEmail}
        showAuthModal={showAuthModal}
        showSocialAuth={showSocialAuth}
        showCancelButton={showCancelButton}
        title={title}
      />
    );
  }

  return (
    <PasswordlessOtpStep
      changePayment={changePayment}
      className={className}
      email={email}
      hideAuthModal={hideAuthModal}
      onAuth={onAuth}
      onCancel={() => setEmail('')}
      remember={defaultValues?.signInRemember ?? true}
      showAuthModal={showAuthModal}
      title={title}
    />
  );
};
